(function () {
  'use strict';

  function mediaItems(container) {
    return Array.from(container.children).filter(function (item) {
      return item.matches('li, div, figure') && item.querySelector('img, video, model-viewer, iframe');
    });
  }

  function findGallery() {
    var selectors = [
      '.product__media-list',
      '[data-media-gallery] .slider',
      '[data-product-media-list]',
      '.product-media-gallery__list',
      '.product-gallery__media-list',
      '.product__media-wrapper ul',
      '.product__media-wrapper [role="list"]',
      '.product-gallery ul',
      '.product-gallery [role="list"]'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var candidate = document.querySelector(selectors[i]);
      if (candidate && mediaItems(candidate).length > 1) return candidate;
    }

    var root = document.querySelector('main') || document.body;
    var candidates = Array.from(root.querySelectorAll('[class*="gallery"], [class*="media-list"], [class*="media__list"], [class*="slider"]'));
    candidates = candidates.filter(function (candidate) {
      var className = String(candidate.className || '').toLowerCase();
      return className.indexOf('thumb') === -1 && mediaItems(candidate).length > 1;
    });

    candidates.sort(function (a, b) {
      return mediaItems(a).length - mediaItems(b).length;
    });
    return candidates[0] || null;
  }

  function enhance(gallery) {
    if (!gallery || gallery.dataset.komikoEnhanced === 'true') return;
    var items = mediaItems(gallery);
    if (items.length < 2) return;

    gallery.dataset.komikoEnhanced = 'true';
    gallery.classList.add('komiko-gallery-ready');
    gallery.setAttribute('tabindex', '0');
    gallery.setAttribute('aria-label', 'Galería de imágenes del producto');

    var shell = gallery;
    shell.classList.add('komiko-gallery-shell');

    var controls = document.createElement('div');
    controls.className = 'komiko-gallery-controls';

    var previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'komiko-gallery-arrow komiko-gallery-arrow--prev';
    previous.setAttribute('aria-label', 'Imagen anterior');
    previous.innerHTML = '&#8249;';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'komiko-gallery-arrow komiko-gallery-arrow--next';
    next.setAttribute('aria-label', 'Siguiente imagen');
    next.innerHTML = '&#8250;';

    var dots = document.createElement('div');
    dots.className = 'komiko-gallery-dots';
    dots.setAttribute('aria-label', 'Seleccionar imagen');

    var current = 0;
    var dotButtons = [];

    items.forEach(function (item, index) {
      item.classList.add('komiko-gallery-item');
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'komiko-gallery-dot';
      dot.setAttribute('aria-label', 'Ver imagen ' + (index + 1));
      dot.addEventListener('click', function () { show(index); });
      dots.appendChild(dot);
      dotButtons.push(dot);
    });

    function show(index) {
      var previousIndex = current;
      current = (index + items.length) % items.length;
      var direction = current === previousIndex ? 0 : ((index > previousIndex || (previousIndex === items.length - 1 && current === 0)) ? 1 : -1);
      items.forEach(function (item, itemIndex) {
        var active = itemIndex === current;
        item.classList.toggle('is-active', active);
        item.classList.remove('komiko-from-left', 'komiko-from-right');
        if (active && direction !== 0) item.classList.add(direction > 0 ? 'komiko-from-right' : 'komiko-from-left');
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dotButtons.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    previous.addEventListener('click', function () { show(current - 1); });
    next.addEventListener('click', function () { show(current + 1); });
    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') show(current - 1);
      if (event.key === 'ArrowRight') show(current + 1);
    });

    var touchStartX = 0;
    gallery.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      var distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 45) return;
      show(distance > 0 ? current - 1 : current + 1);
    }, { passive: true });

    controls.appendChild(previous);
    controls.appendChild(next);
    controls.appendChild(dots);
    shell.appendChild(controls);
    show(0);
  }

  function init() {
    if (!document.body.classList.contains('template-product') && window.location.pathname.indexOf('/products/') === -1) return;
    enhance(findGallery());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  var observer = new MutationObserver(function () {
    var gallery = findGallery();
    if (gallery && gallery.dataset.komikoEnhanced !== 'true') enhance(gallery);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
